<template>
  <v-app>
    <div style="position: fixed; height: 100vh; background-color: #222">
      <v-img src="@/assets/login.jpg" width="100vw" height="100vh" />
    </div>
    <v-container id="fundo" class="p-0 fill-height" fluid>
      <v-row class="fill-height" align="center" justify="center">
        <v-col cols="11" sm="8" md="5" lg="4" style="padding: 0px">
          <v-container :style="$vuetify.breakpoint.xs ? 'padding: 4px' : ''">
            <v-card color="white" style="padding: 12px">
              <v-container class="pb-2">
                <v-row
                  class="layout-logos-login fill-height px-4 height"
                  align="center"
                  justify="center"
                >
                  <v-img
                    class="logo-form-login educampo"
                    :src="logo"
                    height="120px"
                    contain
                  />
                </v-row>
              </v-container>
              <div v-if="!loader">
                <v-form
                  id="form_login"
                  ref="form_login"
                  v-model="valid"
                  @submit.prevent="postLogin"
                >
                  <v-container class="p-4">
                    <v-text-field
                      v-model="email"
                      :rules="[rules.required]"
                      light
                      label="Email"
                      name="email"
                      prepend-inner-icon="mdi-email"
                    />
                    <v-text-field
                      v-model="password"
                      light
                      prepend-inner-icon="mdi-key"
                      :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="[rules.required]"
                      :type="show2 ? 'text' : 'password'"
                      name="password"
                      label="Senha"
                      counter
                      @click:append="show2 = !show2"
                    />
                    <div class="mb-3 justify-center">
                      <v-btn text small color="#757575" @click="recuperarSenha">
                        Esqueci minha senha
                      </v-btn>
                    </div>
                    <v-row justify="center" class="pt-4">
                      <v-btn color="success" class="mr-4" type="submit">
                        Acessar
                      </v-btn>
                    </v-row>
                  </v-container>
                </v-form>
              </div>
              <v-container v-else class="pa-6">
                <v-row justify="space-around">
                  <v-progress-circular
                    :size="100"
                    :width="7"
                    color="primary"
                    :indeterminate="true"
                  />
                </v-row>
              </v-container>
            </v-card>
          </v-container>
        </v-col>
      </v-row>
      <v-snackbar
        v-model="snackbar"
        multi-line
        top
        :timeout="13500"
        color="error"
      >
        {{ message }}
        <v-btn dark text @click="snackbar = false"> Fechar </v-btn>
      </v-snackbar>
    </v-container>
  </v-app>
</template>
<script>
import { ENV_APP } from '../../../env'
import { login } from '../../services/AuthService'
export default {
  props: {
    backgroundImage: {
      type: String,
      default: 'static/img/login.jpg',
    },
  },
  data() {
    return {
      email: null, //
      password: null,
      emailRules: [v => /.+@.+/.test(v) || ''],
      requiredRules: [v => !!v || ''],
      user: null,
      snackbar: false,
      message: '',
      loader: false,
      valid: null,
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      rules: {
        required: value => !!value || 'Obrigatório.',
        emailMatch: () => 'O email ou a senha estão incorretos',
      },
    }
  },

  computed: {
    logo() {
      return 'img/' + `${ENV_APP.imgFileLogin}`
    },
  },

  methods: {
    postLogin() {
      if (this.$refs.form_login.validate()) {
        this.loader = true
        this.api.auth
          .login(this.email, this.password)
          .then(data => {
            login(data.user, data.access_token)
            this.$router.push('/')
          })
          .catch(error => {
            this.loader = false
            this.snackbar = true
            this.message = error[0]
          })
      }
    },
    recuperarSenha() {
      this.$router.push('/recuperar-senha')
    },
  },
}
</script>
<style scope lang="scss">
.senha {
  color: rgb(40, 57, 211);
}
.senha:hover {
  color: rgb(29, 115, 245);
}

.outline-login .container .v-input .v-input__control .v-input__slot {
  border: 2px solid #005bb9;
}

.logo-form-login.educampo .v-image__image--cover {
  background-size: contain;
  background-position: center !important;
}

.logo-form-login.sebrae .v-image__image--cover {
  background-size: contain;
  background-position: center !important;
}

html {
  overflow: auto;
}

.headline {
  font-family: 'Poppins', sans-serif !important;
}

.display-grid {
  display: grid;
  height: auto !important;
  .flex {
    background-color: white;
    padding: 7px;
    margin-bottom: 70%;
    .v-responsive.v-image {
      margin-top: 6px;
      padding: 0px 0.7px;
    }
  }
}

.apresentacao {
  font-size: 24px;
  font-family: 'Poppins', sans-serif;
}

.layout-login-row {
  margin-right: 0px !important;
  margin-left: 0px !important;
}

.demonstracao span {
  font-size: 1rem !important;
  font-weight: bold;
  letter-spacing: 0.009375em !important;
  line-height: 1.357rem;
  font-family: 'Roboto', sans-serif !important;
  color: #fff;
}

.requisitar-demonstracao {
  font-size: 1.2rem !important;
  font-weight: bold;
  letter-spacing: 0.009375em !important;
  line-height: 1.75rem;
  font-family: 'Roboto', sans-serif !important;
  color: #4e5152;
}

@media (min-width: 41em) {
  #fundo {
    background-size: auto;
  }
} /* 656px */

@media (min-width: 47em) {
  #fundo {
    background-size: auto;
  }
} /* 752px */

@media (min-width: 68em) {
  #fundo {
    background-size: auto;
  }
} /* 1088px */

@media (min-width: 82em) {
  #fundo {
    background-size: auto;
  }
} /* 1312px */

@media (min-width: 100em) {
  #fundo {
    background-size: contain;
  }
  .layout-logos-login {
    align-items: center !important;
  }
  .tela-login.flex .v-card {
    height: 316px;
  }
  .headline {
    font-size: 34px !important;
  }
  .logo-form-login.educampo {
    height: 110px !important;
  }
  .logo-form-login.sebrae {
    height: 70px !important;
    padding-bottom: 20px;
  }
} /* 1600px */
</style>
